import React from 'react';
import { NavItem } from 'reactstrap';

import { slugify } from '../../app/general';

const Arrow = ({ text, className }) => {
  return (
    <div
      className={className}
    >{text}</div>
  );
};

export const ArrowLeft = Arrow({ text: '<', className: 'arrow-prev' });
export const ArrowRight = Arrow({ text: '>', className: 'arrow-next' });

const MenuItem = ({ name, slug, selected }) => {
  return <NavItem className={`menu-item ${selected ? 'active' : ''}`}>
    <div
      className={name.length > 25 ? 'nav-link nav-link--long' : 'nav-link'}
      data-slug={`#category-${slug}`}>
      {name}
    </div>
  </NavItem>;
};

const generateMenu = (categories, selected) =>
  categories.map(cat => {
    const { name } = cat;
    const slug = slugify(name);

    return <MenuItem key={slug} name={name} slug={slug} selected={selected} />;
  });

export default generateMenu;
